import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getDrivingData, getFinDrivingData } from "../../../../store/Api";
import { setAppError, setBreadCrumb } from "../../../../store/userSlice";
import FileUploadElement from "../../../../ReusableComponents/UploadFile/uplaodFile";
import FinListDrivingLicence from "./FinListDrivingLic";

export default function FinDrivingLicence() {
  const drivingLicData = useSelector((state) => state.finDrivingData);

  //screen Title Show fun
  const titleBorder = [
    { label: "Driving Licence", link: "/dashboard/driving" },
  ];

  const dispatch = useDispatch();

  const [loading, setLoading] = useState({
    updateData: false,
    uploadFile: false,
    listData: false,
    loadingId: "",
  });
  const token = localStorage.getItem("nodeToken");
  useEffect(() => {
    dispatch(setBreadCrumb(titleBorder));
    dispatch(getFinDrivingData(token));
  }, []);

  const updateData = () => {
    dispatch(getFinDrivingData(token));
  };

  return (
    <div className={`ml-5 mr-5`}>
      <FinListDrivingLicence
        titles={[
          "SR.NO.",
          "Employee ID",
          "Employee NAME",
          "ACTUAL PROFESSION",
          "IQAMA PROFESSION",
          "VISA PROVIDER",
          "SPONSOR ID",
          "CLIENT NAME",
          "IQAMA NUMBER",
          "LICENCE TYPE",
          "DRIVING LICENCE APPLY DATE",
          "DRIVING LICENCE ISSUE DATE",
          "DRIVING LICENCE EXPIRY DATE",
          "DRIVING LICENCE VALID DAYS",
          "DRIVING LICENCE ADMISSION FEES",
          "DRIVING LICENCE MEDICAL FEES",
          "DRIVING LICENCE GOVT. FEES",
          "DRIVING LICENCE INDUCEMENTS FEES",
          "LICENCE STATUS",
          "checkBox",
        ]}
        list={drivingLicData.data}
        loading={loading}
        token={token}
        callBack={updateData}
      />
    </div>
  );
}
